var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 487,
    viewBox: "0 0 423 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_d_75_4519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.742 430.296L248.251 335.176L330.34 383.212L329.832 478.265L247.742 430.296Z",
    fill: "#60F770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.23 431.122L412.738 336.194L330.34 383.153L329.832 478.014L412.23 431.122Z",
    fill: "#57DE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.184 335.185L330.716 287.658L412.805 336.069L330.274 383.22L248.184 335.185Z",
    fill: "#79F786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3305 429.037L84.8392 333.917L166.929 381.952L166.42 477.005L84.3305 429.037Z",
    fill: "#087BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.059 429.854L248.568 334.926L166.17 381.944L165.661 476.805L248.059 429.846V429.854Z",
    fill: "#076FE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2638 334.234L166.795 286.707L248.885 335.118L166.353 382.269L84.2638 334.234Z",
    fill: "#3B96FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81652 287.466V192.346L85.0894 239.873V334.926L2.81652 287.458V287.466Z",
    fill: "#FFEF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.603 287.466V192.346L84.3305 239.873V334.926L166.603 287.458V287.466Z",
    fill: "#E6D735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49962 192.722L84.7725 144.753L167.045 192.722L84.7725 240.315L2.49962 192.722Z",
    fill: "#FFF36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7142 145.07L85.2229 49.9503L167.312 97.9855L166.804 193.039L84.7142 145.07Z",
    fill: "#FF2929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.577 145.954L250.086 50.6424L167.304 97.8521L166.795 193.097L249.577 145.946V145.954Z",
    fill: "#E62525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3397 50.2672L167.871 2.74063L249.961 51.1512L167.429 98.2357L85.3397 50.2672Z",
    fill: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.577 145.896L249.769 50.901L331.858 98.5526L331.666 193.481L249.577 145.887V145.896Z",
    fill: "#FF70DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.064 146.213L414.256 51.0928L331.858 98.561L331.666 193.614L414.064 146.213Z",
    fill: "#E665C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51 51.2179L331.85 3.30771L414.064 51.4013L331.725 98.8695L249.51 51.2179Z",
    fill: "#FFA3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.799 49.2414C415.382 48.9996 333.234 0.947638 333.234 0.947638C332.384 0.447271 331.324 0.447271 330.465 0.947638L249.794 47.8821L169.264 0.380549C168.413 -0.119819 167.354 -0.128162 166.495 0.363866C166.495 0.363866 84.2805 47.5652 83.8802 47.7904C83.0295 48.274 82.4707 48.9579 82.4624 49.9336L81.9703 143.202L2.28277 189.661C1.99087 189.72 0.448001 190.553 0.231164 190.854C-0.16081 191.696 0.0643692 193.964 0.0643692 193.964V287.458C0.0643692 288.442 0.589776 289.343 1.44044 289.835L81.9453 336.277C81.9787 336.344 82.037 336.394 82.0787 336.461L81.5867 429.012C81.5867 429.996 82.1038 430.905 82.9461 431.397L163.501 478.473C163.601 478.607 164.819 479.432 166.061 479.382C167.404 479.332 168.647 478.298 168.897 478.115L247.5 433.323L328.447 480.625C328.872 480.875 329.356 481 329.832 481C330.307 481 330.874 480.792 331.191 480.641C352.541 470.275 413.589 433.49 413.589 433.49C414.44 433.006 414.973 432.097 414.973 431.122L415.474 336.536C415.532 335.652 415.032 334.184 414.189 333.684L332.108 285.273C331.258 284.773 330.199 284.764 329.348 285.256L248.609 331.749L169.356 285.006V194.79L249.627 149.073L329.698 195.499C329.873 195.682 330.073 195.841 330.29 195.966C330.716 196.216 331.191 196.333 331.666 196.333C332.142 196.333 332.609 196.208 333.034 195.966L415.432 148.564C416.283 148.072 416.808 147.172 416.808 146.188L417 51.0678C417 50.0837 416.65 49.7001 415.799 49.208V49.2414ZM409.494 429.521L332.6 473.278L333.067 384.771L350.323 374.914L409.961 340.922L409.486 429.512L409.494 429.521ZM330.699 290.827L407.334 336.027L347.454 370.235L330.307 380.009L253.697 335.176L330.707 290.827H330.699ZM251.278 340.172L327.58 384.821L327.104 473.503L250.803 428.912L251.278 340.172ZM246.833 144.361L169.564 188.369L169.781 147.305L170.031 99.9119L247.008 55.9964L246.833 144.361ZM167.854 5.91795L244.114 50.8926L167.212 94.7498L91.0191 50.1671L167.854 5.91795ZM164.543 99.7368L164.202 163.942L164.076 187.818L87.4663 143.152L87.9333 54.9706L164.543 99.7451V99.7368ZM81.5867 329.739L5.56035 285.882V197.667L81.5867 241.641V329.739ZM8.45429 192.43L84.4723 148.106L160.64 192.622L84.7141 236.487L8.45429 192.438V192.43ZM163.86 197.742V285.231L87.8333 329.013V241.724L163.86 197.75V197.742ZM162.942 471.793L87.091 427.461L87.5581 339.338L163.409 383.729L162.942 471.793ZM245.007 428.436L169.189 471.643L169.656 383.537L245.474 340.222L245.007 428.436ZM243.088 334.893L166.562 378.558L90.919 334.292L167.337 290.21L243.088 334.893ZM328.931 188.727L252.337 144.32L252.804 56.2966L329.106 100.529L328.931 188.727ZM331.858 95.3836L255.373 50.9844L331.85 6.49337L408.418 51.2929L331.858 95.392V95.3836ZM411.321 144.62L334.418 188.861L334.585 105.349V100.387L411.504 56.0548L411.329 144.62H411.321Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_4519",
    x: 0,
    y: 0,
    width: 423,
    height: 487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_4519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_4519",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fbf9d6ffb99d0e1f2deb576c9058f35e.svg";
export { ForwardRef as ReactComponent };